/* build/tpl */
import deps from './deps/mapValuesDeep.js';
import getMapValuesDeep from './getMapValuesDeep.js';
export default getMapValuesDeep(deps);
